<template>
    <div>
        <section class="main-slider">
            <div class="page-header-bg" style="background-image: url(static/picture/banner/B2.jpg);">
            </div>
            <div class="container">
                <div class="page-header__inner">
                    <h1>
                        <!-- 解决方案 -->
                         {{ $t('solution.solution_page_title') }}
                    </h1>
                    <h3>
                        <!-- 聚焦工业互联网行业，为企业提供360°解决方案，助力企业数字化转型升级，赋能中国制造业创新发展 -->
                        {{ $t('solution.solution_page_title') }}
                    </h3>
                </div>
                <div class="page-header__breul">
                    <el-breadcrumb separator="/" >
                        <el-breadcrumb-item :to="{ path: 'home' }">
                            <!-- 首页 -->
                            {{ $t('solution.solution_breadcrumb_home') }}
                        </el-breadcrumb-item>
                        <el-breadcrumb-item>
                            <!-- 解决方案 -->
                            {{ $t('solution.solution_breadcrumb_current') }}
                        </el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </div>
        </section>
      
        <section class="welcome-one">
			<div class="container">
                <!-- 工业互联网 -->
                <div class="row" >
                    <div class="container_row_title">
                            <h4 >
                                <!-- 行业解决方案 -->
                                 {{ $t('solution.solution_industry_title') }}
                            </h4>
                    </div>
                    <div class="col-xl-4 col-lg-12 wow fadeInUp row__item" v-for="(item,index) in solutionList" :key="index"  :data-wow-delay="(index+1)+'ms'" @click="handleDetail(item)" >
                        <div style="position: relative; display: block;margin: 10px;">
                            <template v-if="item.type == 'text'">
                                <img  :src="item.imgUrl" />
                                <div class="row__item_text">
                                    <span :class="handleIcon(item)">
                                    <i class="row__item_text_icon" :class="item.icon" ></i>
                                    </span>
                                    <h3 class="row__item_text_title">
                                        {{ item.title }}
                                          <!-- {{ $t(`solution.${item.i18n_title}`) }} -->
                                    </h3>
                                    <p class="row__item_text_conter" style="line-height: 20px;">
                                        {{ item.text }}
                                         <!-- {{ $t(`solution.${item.i18n_text}`) }} -->
                                    </p>
                                </div>
                               
                            </template>
                        
                            <template v-else>
                                <img  :src="item.imgUrl" />
                                <h4 class="row__item_text_title">
                                    {{ item.title }}

                                    <!-- {{ $t(`solution.${item.i18n_title}`) }} -->
                                    <p class="row__item_text_conter">
                                        {{ item.text }}
                                        <!-- {{ $t(`solution.${item.i18n_text}`) }} -->
                                    </p>
                                </h4>
                            </template>
                        </div>
                    </div>
                </div>
			</div>
		</section>
        <!-- <section class="welcome-two">
			<div class="container">
                <div class="row" >
                    <div class="container_row_title">
                            <h4 >车间信息化升级</h4>
                    </div>
                    <div class="col-xl-12 col-lg-12 wow fadeInUp">
                        <div style="text-align: center;">
                            <img style="max-width: 100%" src="static/picture/solution/workshop.png" />
                        </div>
                        <div>
                            <p style="text-indent:2em; font-size: var(--font-size-16)" >
                                现场焊机：将车间现有焊机通过设备改造，实现焊接数据采集，包括焊接电流、焊接电压、保护气体流量、送丝速度等数据的实时采集。
                            </p>
                            <p style="text-indent:2em; font-size: var(--font-size-16)" >
                                网络传输： 根据客户实际车间情况，企业可以选择焊机采用无线WiFi、4G、5G等方式。
                            </p>
                            <p style="text-indent:2em; font-size: var(--font-size-16)" >
                                系统应用：智能焊接生产管理系统为企业提供焊生产在线派工、焊接设备远程监控、焊工工时统计、接数据在线分析，焊接成本统计报表等功能。系统采用B/S(浏览器/服务器)或其他网络架构，可方便的通过企业网络实现数据远程访问、及可实现与企业信息系统对接实现数据共享。
                            </p>
                        </div>
                    </div>
                </div>
			</div>
		</section> -->
    </div>
</template>

<script >
import { MixinsList } from '@/mixins/mixins' 
import { loadData } from '@/utils/dataLoader'
export default {
    name: 'list',
     mixins: [MixinsList],
    components: {

    },
    data () {
        return {
            solutionList: [],
        }
    },
    created() {
        this.getList()  // 获取内容
    },
    mounted () {
         // 确定选中的菜单
        $('.current').removeClass('current');  
        $('.solution_li').addClass('current');
    },
    methods: {
        // 
        handleIcon(item) {
            if(item.position == "left") {
                return 'icon_left'
            } else if(item.position == "right") {
                return 'icon_right'
            }
        },
        // 获取内容
        async getList() {
            // const { result } = res
            // this.solutionList = JSON.parse(JSON.stringify(result.programmeList))  
            try {
                const  result  = await loadData('solutionList', this.lang)
                this.solutionList = JSON.parse(JSON.stringify(result.programmeList))  
             } catch (error) {
                console.log(error)
                this.solutionList= []
            }
        },
        // 详情
        handleDetail(item) {
            if(item.path) {
                if(item.value) {
                    this.$router.push({
                        path: item.path,
                        query: {
                            type: item.value
                        }
                    });
                } else {
                    this.$message.warning(this.$t('solution.solution_unavailable_warning'));
                }
               
            } else {
                if(item.value) {
                    this.$message.warning(this.$t('solution.solution_unavailable_warning'));
                }
            }
         
          
        }
    }
}
</script>
<style scoped>
.page-header-bg {
    background-color: transparent; 
}
.page-header__inner h1 {
    font-size: var(--font-size-40);
}

/* 面包屑 */
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner {
    color: var(--notech-white) ;
}
::v-deep .el-breadcrumb__inner {
    /* color: var(--notech-primary) !important; */
    color: var(--notech-white);
    font-size: var(--font-size-16);
    font-weight: 700;
    transition: all 500ms ease;
}
.welcome-one {
    background: var(--notech-extra);
   padding: 60px 0 120px; 
}

.row__item {
    cursor: pointer;
    position: relative;
    /* background-color:#fff; */
    visibility: visible;
    animation-name: fadeInUp;

}
.col-xl-4 {
    padding: 0;
   
}
.row__item img {
    max-width: 100%;
}
.row__item h4 {
    font-size: var(--font-size-24);
    font-weight: bold;
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 40px;
    line-height: 40px;
    padding-left: 20px;
    box-sizing: border-box;
    left: 0;
    line-height: 30px;
    background: linear-gradient(rgba(0,0,0,0),rgba(0,0,0,0.8));
    color: #FFFFFF;
    transition: all 0.6s;
}

.row__item:hover h4 {
    height: 100%;
    background: rgba(0,0,0,0.5);
    transition: all 0.6s;
    padding-top: 20px;
}
.row__item h4 p {
    font-size: var(--font-size-16);
    font-weight: 100;
    display: none;
    transition: all 0.4s;
    padding-right: 20px;
    line-height: 20px;
}
.row__item:hover h4 p{
    display: block;
    transition: all 6s;
    height: calc(100% - 55px);
    overflow: hidden;  
    text-overflow: ellipsis;
    -webkit-line-clamp: 9;
    -webkit-box-orient: vertical;
}
.container_row_title h4{
    font-size: var(--font-size-40);
    text-align: center;
    margin-bottom: 60px;
    line-height: 1.65;
    color: #232e5e;
}

.row__item_text {
    position: absolute;
    width: 100%;
    bottom: 0;
    top: 0px;
    left: 0;
    color: #FFFFFF;
    padding: 50px 30px;
    line-height: 2;
    /* padding: 20px;
    line-height: 20px; */
}
.row__item_text_title {
    font-size: var(--font-size-24);
    color: var(--notech-white);
}
.row__item_text_icon {
    font-size: var(--font-size-66);
   
}
.row__item_text_conter {
    font-size: var(--font-size-16);
    padding: 10px;
    width: 100%;
   
}
.icon_left{
    float: left;
    margin: 0 15px;
    margin-bottom: 50px;
    height: 100%;
}
.icon_right{
    float: right;
    margin: 0 15px;
    margin-bottom: 50px;
}

.welcome-two {
    padding: 30px 0 60px;
}
</style> 
